import React, { useContext } from 'react';
import {
  Button, Col, Container, Row,
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { OrderContext } from '../../../context/OrderContext';
import { CampaignContext } from '../../../context/CampaignWrapper';

import { ReactComponent as BasketIcon } from '../../../assets/icons/basket.svg';
import LinkWithQueryParams from '../../../components/LinkWithQueryParams';

interface HeaderProps {
  openCartModal?: () => void
}

const Header = ({ openCartModal } : HeaderProps) => {
  const { articleCount } = useContext(OrderContext);
  const { campaign: { name, slug, isSellingEnabled } } = useContext(CampaignContext);
  const [translate] = useTranslation();

  return (
    <div className="header sticky-top bg-white">
      <Container>
        <Row className="align-items-center justify-content-around py-2 py-md-3">
          <Col xs={8} className="px-3">
            <p className="m-0 text-muted text-uppercase">{translate('COMPONENTS.HEADER.WEBSHOP')}</p>
            <h5 className="m-0 fw-bold">
              <LinkWithQueryParams to={`/${slug}`} style={{ color: 'inherit' }}>{name}</LinkWithQueryParams>
            </h5>
          </Col>
          <Col xs={4} className="text-end">
            {openCartModal && isSellingEnabled && (
            <Button color="primary" className="header-cart-button px-2 px-md-4" onClick={openCartModal}>
              <div className="d-flex align-items-center gap-2">
                <BasketIcon fill="white" />
                {' '}
                <span className="d-none d-md-inline align-middle">
                  {translate('COMPONENTS.HEADER.SHOPPING_CART')}
                </span>
                {!!articleCount && (
                <span className="header-count-icon">
                  {articleCount}
                </span>
                )}
              </div>
            </Button>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Header;
